<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/imbpuN/CoverDesign.jpg?1684515575651" alt="This image is the cover for the book The More the Merrier, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The More the Merrier, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Teddy Bear Club</i></b></p><p>Too much of a good thing?</p> <p>When Logan gets the call about newborn triplets in need of a home, he steps up, realizing too late the daunting task he’s taken on. He’d be lost without the men of the Teddy Bear Club—especially Dirk.</p> <p>Dirk even offers to spend spring break at Logan’s home, helping him and the babies settle in. He loves being a dad, and he wants to help Logan find the same joy. It doesn’t hurt that they enjoy spending time together.</p> <p>Before they even realize it, they’re settling into a routine… becoming a family.</p> <p>Falling in love.</p> <p>But their new bond is about to face the ultimate test. Will they come through and realize that with love, there’s no such thing as enough?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Michael
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56492d82